module.exports = __webpack_public_path__ + "img/case1.4094d322.png";